const { definitionStrategies: DefinitionStrategies } = require('pando-constants');

const defaultDefinitions = require('./default');
const pngDefinitions = require('./png');
const hachDefinitions = require('./hach');

module.exports = {
  [DefinitionStrategies.DEFAULT]: defaultDefinitions,
  [DefinitionStrategies.PNG]: pngDefinitions,
  [DefinitionStrategies.HACH]: hachDefinitions,
};
